/**
 * Detects non-actionable errors produced by third-party browser widgets
 * (e.g. accessibility overlays) that are injected into the page by external
 * scripts and have nothing to do with application code.
 *
 * Known widgets:
 * - **Parity Digital** – an accessibility overlay whose minified bundle
 *   calls `.filter()` on a value that can be `undefined`, producing:
 *   `t().filter is not a function … "ParityDigital"`.
 */
export function isThirdPartyWidgetNoise(
  message: string | undefined,
  stack: string | undefined,
): boolean {
  if (!message) {
    return false;
  }

  if (message.includes("ParityDigital")) {
    return true;
  }

  if (stack?.includes("ParityDigital")) {
    return true;
  }

  return false;
}
